<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">
            Manage Episodes for {{ mediaItem && mediaItem.title }}
          </h1>
          <div class="buttons-list has-text-right">
            <b-button
              type="is-primary"
              icon-left="plus"
              tag="router-link"
              :to="{ name: 'CreateEpisode' }"
              >Add</b-button
            >
            <b-button
              v-if="anySelected"
              type="is-primary"
              :disabled="loading"
              class="has-margin-left-5"
              :class="{ 'is-loading': loading }"
              @click="deleteEpisodes"
            >
              Delete</b-button
            >
            <b-button
              type="is-default"
              class="has-margin-left-5"
              @click="autoGenerate"
              >Auto Generate</b-button
            >
          </div>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredEpisodes"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="" label="" width="40">
                <b-checkbox v-model="props.row.selected" />
              </b-table-column>

              <b-table-column field="episode_number" label="#" numeric>
                {{ props.row.episode_number }}
              </b-table-column>

              <b-table-column field="title" label="Title">
                {{ props.row.title }}
              </b-table-column>

              <b-table-column label="Duration">
                <b-input
                  v-model="props.row.episodeLength"
                  type="number"
                  rules="required"
                  @input="updateRow(props.row)"
                />
              </b-table-column>

              <b-table-column label="VOD Start Date">
                <BaseDateTimePicker
                  v-model="props.row.vodStartDate"
                  style="position: relative; top: -8px"
                  label=""
                  @input="updateRow(props.row)"
                >
                </BaseDateTimePicker>
              </b-table-column>

              <b-table-column label="VOD Expiry Date">
                <BaseDateTimePicker
                  v-model="props.row.vodExpiryDate"
                  style="position: relative; top: -8px"
                  :min-datetime="props.row.vodStartDate"
                  label=""
                  @input="updateRow(props.row)"
                >
                </BaseDateTimePicker>
              </b-table-column>

              <b-table-column field="qcstatus" label="Auto QC">
                {{ (props.row.qcstatus || 'Not Available') | capitalize }}
                <a
                  v-if="props.row.qcstatus && props.row.qcstatus === 'failed'"
                  href=""
                  @click.prevent="showQcJobResult(props.row)"
                  >View Errors</a
                >
              </b-table-column>
              <!-- <b-table-column field="manualqcstatus" label="Manual QC">
                <a href="" @click.prevent="changeManualStatus(props.row)">{{
                  (props.row.manualqcstatus || 'Not Available') | capitalize
                }}</a>
              </b-table-column> -->
              <b-table-column v-if="mediaItem" label="File Name For Upload:">
                <p>
                  {{ generateFileName(mediaItem, props.row) }}
                </p>
                <a
                  href=""
                  @click.prevent="
                    copyText(generateFileName(mediaItem, props.row))
                  "
                  >COPY</a
                >
              </b-table-column>

              <b-table-column label="Actions">
                <b-button
                  class="has-margin-right-10"
                  @click="
                    $router.push({
                      name: 'EditEpisode',
                      params: { id: props.row.id }
                    })
                  "
                  >Edit</b-button
                >
                <b-button
                  class="has-margin-right-10"
                  @click="confirmDelete(props.row)"
                  >Delete</b-button
                >
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No episodes yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to delete this episode?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="deleteEpisode()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
    <ChangeManualQCStatusModal
      v-if="showChangeManualQCStatusModal"
      :show="showChangeManualQCStatusModal"
      :media="item"
      :is-episode="true"
      @close-modal="showChangeManualQCStatusModal = false"
    >
    </ChangeManualQCStatusModal>
    <ViewHybrikJobResultModal
      v-if="showViewHybrikJobResultModal"
      :show="showViewHybrikJobResultModal"
      :job-id="item.job_id"
      @close-modal="showViewHybrikJobResultModal = false"
      @refresh="fetchEpisodes"
    >
    </ViewHybrikJobResultModal>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import MediaApi from '@/api/media'
import EpisodeApi from '@/api/episodes'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'
import ChangeManualQCStatusModal from '@/components/ChangeManualQCStatusModal'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import ViewHybrikJobResultModal from '@/components/ViewHybrikJobResultModal'
import HybrikApi from '@/api/hybrik'

export default {
  name: 'ManageEpisodes',
  components: {
    CardComponent,
    BaseDateTimePicker,
    ChangeManualQCStatusModal,
    ViewHybrikJobResultModal
  },
  mixins: [Filters, Utils],
  metaInfo: {
    title: 'Manage Episodes'
  },
  computed: {
    ...mapGetters(['user']),
    anySelected() {
      if (this.filteredEpisodes && this.filteredEpisodes.length > 0) {
        return this.filteredEpisodes.find(item => item.selected)
      }
      return false
    },
    filteredEpisodes() {
      if (this.search !== '' && this.items.length > 0) {
        let query = this.search.toLowerCase()
        return this.items.filter(
          item =>
            item.title.toLowerCase().includes(query) ||
            item.description.toLowerCase().includes(query)
        )
      } else {
        return this.items
      }
    }
  },
  async created() {
    this.fetchEpisodes()
  },
  data() {
    return {
      mediaItem: null,
      loading: true,
      items: [],
      search: '',
      showConfirmModal: false,
      showChangeManualQCStatusModal: false,
      showViewHybrikJobResultModal: false,
      item: {}
    }
  },
  methods: {
    ...mapActions(['getUser']),
    showQcJobResult(item) {
      this.item = item
      this.showViewHybrikJobResultModal = true
    },
    changeManualStatus(item) {
      this.item = item
      this.showChangeManualQCStatusModal = true
    },
    updateRow(item) {
      item.episodeNumber = item.episode_number
      item.episodedata = {
        releaseDate: item.releaseDate,
        episodeLength: item.episodeLength,
        vodStartDate: item.vodStartDate,
        vodExpiryDate: item.vodExpiryDate,
        ageRestriction: item.ageRestriction
      }
      EpisodeApi.update(item)
        .then(() => {})
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error updating episode',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    deleteEpisodes() {
      let items = this.filteredEpisodes.filter(item => item.selected)
      this.$buefy.dialog.confirm({
        message: `Are you sure you want to delete the ${items.length} episodes?`,
        onConfirm: async () => {
          this.loading = true
          await EpisodeApi.removeMultiple(items.map(item => item.id))
          this.$buefy.toast.open({
            message: 'Episodes removed successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
          this.items = this.items.filter(item => !item.selected)
        }
      })
    },
    confirmDelete(item) {
      this.showConfirmModal = true
      this.item = item
    },
    deleteEpisode() {
      EpisodeApi.remove({
        episodeId: this.item.id
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Episode deleted successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.fetchEpisodes()
          this.showConfirmModal = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error deleting episode',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    async fetchEpisodes() {
      this.loading = true
      this.mediaItem = await MediaApi.getById(this.$route.params.id)
      if (this.mediaItem.mediadata && this.mediaItem.mediadata !== '') {
        this.mediaItem.mediadata = JSON.parse(this.mediaItem.mediadata)
      }
      if (this.mediaItem.metadata && this.mediaItem.metadata !== '') {
        this.mediaItem.metadata = JSON.parse(this.mediaItem.metadata)
      }

      const jobs = await HybrikApi.getAll()
      EpisodeApi.getAllByMediaId(this.$route.params.id).then(items => {
        items.forEach(item => {
          item.episodeId = item.id
          item.episode_number = parseInt(item.episode_number, 10)
          if (item.episodedata && item.episodedata !== '') {
            item.episodedata = JSON.parse(item.episodedata)
            if (item.episodedata.episodeLength) {
              item.episodeLength = item.episodedata.episodeLength
            }
            if (item.episodedata.vodStartDate) {
              item.vodStartDate = item.episodedata.vodStartDate
                ? new Date(item.episodedata.vodStartDate)
                : undefined
            }
            if (item.episodedata.vodExpiryDate) {
              item.vodExpiryDate = item.episodedata.vodExpiryDate
                ? new Date(item.episodedata.vodExpiryDate)
                : undefined
            }
          }

          if (this.mediaItem) {
            // loop through jobs and match on name format
            const matchedJob = jobs.items.find(job =>
              job.name.includes(this.generateFileName(this.mediaItem, item))
            )
            if (matchedJob) {
              item.qcstatus = matchedJob.status
              item.job_id = matchedJob.id
            }
          }
        })
        this.items = sortBy(items, 'episode_number')
        this.loading = false
      })
    },
    async autoGenerate() {
      this.loading = true
      await EpisodeApi.autoGenerate(this.$route.params.id)
      this.fetchEpisodes()
      this.$buefy.toast.open({
        message: 'Episodes auto-generated successfully!',
        position: 'is-top',
        type: 'is-success'
      })
    },
    async copyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext)
        alert('Copied')
      } catch ($e) {
        alert('Cannot copy')
      }
    }
  }
}
</script>
